import { createContext, useReducer } from 'react';
import { medicalReducer } from '../reducers/medicalReducer';

import { medical, education, auth } from '../initialState';
import { medicalActions, educationActions, authAction } from '../actionType';
import { educationReducer } from '../reducers/educationReducer';
import { userReducer } from '../reducers/userReducer';

export const RootContext = createContext({
    medical: {
        selectBtn: "specialist"
    },
    saveSelectBtn: (btn) => { },

    education: {
        teacher: [],
        msg: ""
    },
    saveTeacher: (payload) => { },
    authValue: {
        user: null,
        userOwnedData: null
    },
    saveUser: (user) => { },
    removeUser: () => { },
    saveUserOwnedData: (data) => { }
});

function RootContextProvider({ children }) {
    const [medicalState, medicalDispatch] = useReducer(medicalReducer, medical);
    const [educationState, educationDispatch] = useReducer(educationReducer, education);
    const [authState, authDispatch] = useReducer(userReducer, auth)

    const value = {
        //medical
        medical: medicalState,
        saveSelectBtn: (btn) => medicalDispatch({ type: medicalActions.SAVE_SELECT_BTN, payload: btn }),
        education: educationState,
        saveTeacher: (payload) => educationDispatch({ type: educationActions.SAVE_TEACHER, payload: payload }),
        authValue: authState,
        saveUser: (payload) => authDispatch({ type: authAction.SAVE_USER, payload: payload }),
        removeUser: () => authDispatch({ type: authAction.REMOVE_USER }),
        saveUserOwnedData: (payload) => authDispatch({ type: authAction.SAVE_USER_OWNED_DATA, payload: payload })
    }

    return <RootContext.Provider value={value}>
        {children}
    </RootContext.Provider>
}

export default RootContextProvider;